import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timezone: String,
    slotSize: Number
  }

  connect() {
    // Listen for selection events from calendar grids
    this.selectionHandler = this.handleSelection.bind(this)
    this.element.addEventListener('calendar:selection', this.selectionHandler)
  }

  disconnect() {
    this.element.removeEventListener('calendar:selection', this.selectionHandler)
  }

  handleSelection(event) {
    const { startTime, endTime, gridType } = event.detail
    
    // Extract day_of_week for weekly schedules from startTime
    let dayOfWeek = null
    if (gridType === 'weekly' && startTime) {
      const startDate = new Date(startTime)
      const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
      dayOfWeek = daysOfWeek[startDate.getDay()]
    }

    // For monthly grid selections, extract day/month/year from startTime
    let yearlyData = null
    if (gridType === 'monthly' && startTime) {
      const startDate = new Date(startTime)
      yearlyData = {
        day: startDate.getDate(),
        month: startDate.getMonth() + 1, // JavaScript months are 0-indexed
        year: startDate.getFullYear()
      }
    }

    const scheduleEvent = new CustomEvent('schedule:selection', {
      detail: {
        startTime,
        endTime,
        gridType,
        dayOfWeek,
        timezone: this.timezoneValue
      },
      bubbles: true
    })
    this.element.dispatchEvent(scheduleEvent)

    // For monthly grid, use 'yearly' schedule type since monthly is a yearly schedule
    const scheduleType = gridType === 'monthly' ? 'yearly' : gridType
    this.showScheduleForm(startTime, endTime, scheduleType, yearlyData, dayOfWeek)
  }

  determineGridType(element) {
    let current = element
    while (current && current !== this.element) {
      if (current.dataset && current.dataset.scheduleGrid) {
        return current.dataset.scheduleGrid
      }
      current = current.parentElement
    }

    const slot = element.closest('.slot')
    if (slot && slot.dataset.scheduleGrid) {
      return slot.dataset.scheduleGrid
    }

    return 'daily'
  }

  selectDay(event) {
    const dayCell = event.currentTarget
    const day = parseInt(dayCell.dataset.day)
    const month = parseInt(dayCell.dataset.month)
    const year = parseInt(dayCell.dataset.year)

    const scheduleEvent = new CustomEvent('schedule:selection', {
      detail: {
        day,
        month,
        year,
        gridType: 'yearly',
        timezone: this.timezoneValue
      },
      bubbles: true
    })
    this.element.dispatchEvent(scheduleEvent)

    this.showScheduleForm(null, null, 'yearly', { day, month, year })
  }

  showScheduleForm(startTime, endTime, gridType, yearlyData = null, dayOfWeek = null) {
    const url = new URL('/schedules/new', window.location.origin)
    if (gridType) {
      url.searchParams.set('schedule_type', gridType)
    }
    if (startTime && endTime) {
      url.searchParams.set('start_time', new Date(startTime).toISOString())
      url.searchParams.set('end_time', new Date(endTime).toISOString())
    }
    if (yearlyData) {
      if (yearlyData.day) url.searchParams.set('day', yearlyData.day)
      if (yearlyData.month) url.searchParams.set('month', yearlyData.month)
      if (yearlyData.year) url.searchParams.set('year', yearlyData.year)
    }
    if (dayOfWeek) {
      url.searchParams.set('day_of_week', dayOfWeek)
    }
    // Preserve timezone from current page
    const currentTimezone = new URLSearchParams(window.location.search).get('timezone')
    if (currentTimezone) {
      url.searchParams.set('timezone', currentTimezone)
    }
    window.location.href = url.toString()
  }
}

